import React from 'react';
import { Col, Row } from 'react-bootstrap';
import SalesChartContainer from './SalesChartContainer';
import WorldSalesMap from './WorldSalesMap';

const DashboardSalesSection = ({
    salesChartData,
    worldSalesData,
    currencyCode,
}) => {
    return (
        <Row>
            <Col xs={12} md={8} lg={8}>
                <SalesChartContainer
                    data={salesChartData}
                    currencyCode={currencyCode}
                />
            </Col>

            <Col
                xs={12}
                md={4}
                lg={4}
                className="pt-4 pt-lg-0 pt-md-0"
            >
                <WorldSalesMap
                    data={worldSalesData}
                    currencyCode={currencyCode}
                />
            </Col>
        </Row>
    );
};

export default DashboardSalesSection;